type FractionItem = { maxThreshold: number; step: number };
type FractionStep = { up: number; down: number };

const fractionList: FractionItem[] = [
  { maxThreshold: 200, step: 1 },
  { maxThreshold: 500, step: 2 },
  { maxThreshold: 2000, step: 5 },
  { maxThreshold: 5000, step: 10 },
  // For handling largest value directly from loop
  { maxThreshold: Infinity, step: 25 },
];

export const getFraction = (price: number) => {
  const fraction: FractionStep = { up: null, down: null };
  // Loop fraction list to set up and down fraction step, if both exist loops break
  for (let i = 0; i < fractionList.length; i += 1) {
    const { maxThreshold, step } = fractionList[i];
    if (!fraction.up && price < maxThreshold) fraction.up = step;
    if (!fraction.down && price <= maxThreshold) fraction.down = step;

    if (fraction.up && fraction.down) break;
  }

  return fraction;
};

export const getStepFractionByValue = (price: number): FractionStep => {
  const fraction: FractionStep = getFraction(price);

  // Loop fraction list to set up and down fraction step, if both exist loops break
  for (let i = 0; i < fractionList.length; i += 1) {
    const { maxThreshold, step } = fractionList[i];
    if (!fraction.up && price < maxThreshold) fraction.up = step;
    if (!fraction.down && price <= maxThreshold) fraction.down = step;

    if (fraction.up && fraction.down) break;
  }

  // Calculate difference between fraction and price to round to fraction set
  const diffFractUp = price % fraction.up;
  const diffFractDown = price % fraction.down;

  return {
    up: diffFractUp === 0 ? fraction.up : fraction.up - diffFractUp,
    down: diffFractUp === 0 ? fraction.down : diffFractDown,
  };
};
